import React, { FC, ReactElement } from 'react';

interface ITabListProps {
  children: ReactElement[] | ReactElement;
}

export const TabList: FC<ITabListProps> = ({ children }) => {
  return <div className="flex gap-2">{children}</div>;
};

interface ITabProps {
  index: number;
  isActive: boolean;
  label: string;
  onClick: (index: number) => void;
}

export const Tab: FC<ITabProps> = ({ index, isActive, label, onClick }) => {
  return (
    <div
      className={`flex justify-center items-center cursor-pointer rounded-[8px] h-[43px] px-[10px] text-white ${isActive ? 'relative bg-[#211F24] ' : ''} `}
      onClick={() => onClick(index)}
    >
      {isActive ? (
        <span className="absolute left-1/2 -bottom-2 -translate-x-1/2 w-0 h-0 border-l-8 border-r-8 border-t-8 border-l-transparent border-r-transparent border-[#211F24]"></span>
      ) : null}
      {label}
    </div>
  );
};
